export default __webpack_public_path__ + "static/media/sem-items.3dd54da8.png";